<template>
  <div id="campaign">
    <call />
    <!-- main -->
    <main>
    <headTitle title="抽選コード入力" :collback="backPagePrevious" />

      <section :class="{'fade-base': true, 'fade': pageFade}">
        <div class=" c-campaign-code pb-38">
          <div class="p-16 font-size-14"> 
            <p class="pb-24"><b>この抽選会では、抽選に抽選コードが必要です。半角英数8桁の抽選コードを入力してください。</b><br />※最大5つの抽選コードまで同時入力可能</p>

            <div v-if="errorMessage" class="color-7 mb-8">エラー：{{ errorMessage }}</div>
            <div v-if="errorAreaText[0]" class="color-7 mb-8">{{ errorAreaText[0] }}</div>
            <div class="c-box-coupon mb-16" :class="{ 'is-error': errorArea[0]} ">
              <input type="text" value="" v-model="lotteryCode1" placeholder="抽選コード入力" v-on:focus.prevent="onFocus(0)" />
            </div>
            <div v-if="errorAreaText[1]" class="color-7 mb-8">{{ errorAreaText[1] }}</div>
            <div class="c-box-coupon mb-16 " :class="{ 'is-error': errorArea[1] } " >
              <input type="text" value="" v-model="lotteryCode2" placeholder="抽選コード入力" v-on:focus.prevent="onFocus(1)"  />
            </div>
            <div v-if="errorAreaText[2]" class="color-7 mb-8">{{ errorAreaText[2] }}</div>
            <div class="c-box-coupon mb-16"  :class="{ 'is-error': errorArea[2] } ">
              <input type="text" value="" v-model="lotteryCode3" placeholder="抽選コード入力" v-on:focus.prevent="onFocus(2)"  />
            </div>
            <div v-if="errorAreaText[3]" class="color-7 mb-8">{{ errorAreaText[3] }}</div>
            <div class="c-box-coupon mb-16"  :class="{ 'is-error': errorArea[3]} ">
              <input type="text" value="" v-model="lotteryCode4" placeholder="抽選コード入力" v-on:focus.prevent="onFocus(3)"  />
            </div>
            <div v-if="errorAreaText[4]" class="color-7 mb-8">{{ errorAreaText[4] }}</div>
            <div class="c-box-coupon mb-16"  :class="{ 'is-error': errorArea[4]} ">
              <input type="text" value="" v-model="lotteryCode5" placeholder="抽選コード入力" v-on:focus.prevent="onFocus(4)"  />
            </div>
          </div>
          <div class="c-btn c-btn--red box-center" v-bind:class="{ disabled: isLoad }" @click.prevent="applyCampaign()">
            抽選する
          </div>
        </div>
        <div class="c-campaign__conditions">
          <p class="color-2"><b>※参加条件</b></p>
          <p v-html="autolink(campaign.conditions)"></p>
        </div>
      </section>
      <alert :message="alert_msg" 
      :show="alert_show" 
      :closeModal="closeModal" 
      :confirm_show="confirm_show" 
      :confirm_message="confirm_msg" 
      :confirm_callback="confirm_callback" 
      :confirm_hide_cancel="confirm_hide_cancel"
      :label_cancel="confirm_label_cancel"
      :label_ok="confirm_label_ok"
      ></alert>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Alert from "../components/Alert.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getCampaignDetail, isLotteryEntered,getUser, getLotteryEntry } from "../store/firestore.js";
import firebase from "../common/firebaseProject";
const $ = window.$;

import headTitle from "../components/parts/headTitle.vue"


export default Vue.extend({
  name: "CampaignCode",
  components: {
    headTitle,
    Alert
  },
  mixins: [Tenant],
  data () {
    return {
      campaign: {},
      campaignId: this.$route.params.id,
      lotteryCode1: "",
      lotteryCode2: "",
      lotteryCode3: "",
      lotteryCode4: "",
      lotteryCode5: "",
      errorMessage: "",
      errorAreaText:["","","","",""],
      errorArea:[false,false,false,false,false],
      isLoad:false
    }
  },
  async created () {
    this.campaign = await getCampaignDetail(this.campaignId);
    if (!this.campaign) {
        this.$router.replace('/campaign/list');
    }
    this.campaign.conditions = Common.addExtLink(this.campaign.conditions);
  },
  computed: {
  },
  mounted() {
    Common.initDom();
  },
  updated() {
    this.$nextTick(function () {
      Common.setKeepRatio()
    })
  },
  methods: {
    onFocus(index) {
      this.errorArea[index] = false
      this.errorAreaText[index] = ""
    },
    async applyCampaign() {
      if (this.isLoad) return false
      this.errorArea = [false,false,false,false,false];
      this.errorAreaText = ["","","","",""];
      // 最新の状態を確認する
      let campaign = await getCampaignDetail(this.campaignId);
      let isEntered =  campaign.codeType == 2 ? false : await isLotteryEntered(this.SHOP_ID, this.campaignId, this.$store.state.userId);

      if (campaign.isEnded) {
        await this.confirm('予定本数は終了しました', true);
        this.$router.replace(`/campaign/list`);
      } else if (isEntered) {
        await this.confirm('抽選済みです', true);
        this.$router.replace(`/campaign/list`);
      } else {
        if (this.lotteryCode1 == "" && this.lotteryCode2 == "" && this.lotteryCode3 == "" && this.lotteryCode4 == "" && this.lotteryCode5 == "" ) {
          this.errorMessage = "コードを入力してください。";
        } else {

          this.isLoad = true
          const userId = this.$store.state.userId;
          const userData = await getUser(userId);
          const lotteryEntry = await getLotteryEntry(this.campaignId, this.SHOP_ID, userId, [this.lotteryCode1, this.lotteryCode2, this.lotteryCode3, this.lotteryCode4, this.lotteryCode5]);
          const codes = lotteryEntry.map(entry => entry.lotteryCode);
          const callable = firebase.functions('asia-northeast1').httpsCallable('lottery');
          const request = {
            "lotteryId": this.campaignId,
            "userId": userId,
            "lineFootPrint": userData.lineFootPrint,
            lotteryCode1:this.lotteryCode1,
            lotteryCode2:this.lotteryCode2,
            lotteryCode3:this.lotteryCode3,
            lotteryCode4:this.lotteryCode4,
            lotteryCode5:this.lotteryCode5,
          };
          const result = await callable(request)
          .catch(async e => {
            // TODO エラー
            //this.loading = false;
            //await this.alert("エラーが発生しました。" + (e?.message||""), true);
                     this.isLoad = false

            console.log(e)
            throw e;
          });
          this.isLoad = false
          console.log(result)

          if (result.data.status == "FAILED") {
            for (let i = 0; i < 5; i++) {
              const errorCode = `lotteryCode${i + 1}`;
              if (result.data.error && result.data.error[errorCode] !== "") {
                this.errorArea[i] = true;
                this.errorAreaText[i] = "無効なコードです。入力内容やショッピングセンター名に相違がないかご確認ください。";
              }

              if (codes.includes(this[`lotteryCode${i + 1}`])) {
                this.errorAreaText[i] = "すでに抽選済みのコードです。";
              }
            }
          } else {
            this.$router.replace({path:'/campaign/result/'+this.campaignId, params: result,query:  { obj: JSON.stringify(result) }});
          }

        }
      }
    }
  }
})
</script>
